(function () {
  let advantagesSlider = document.querySelector(
    '[data-selector="advantages-slider"]'
  );

  let advantagesImgSlider = document.querySelector(
    '[data-selector="advantages-img-slider"]'
  );

  if (advantagesSlider && advantagesImgSlider) {
    const swiperImgAdvantages = new Swiper(advantagesImgSlider, {
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
      },
    });
    const swiperAdvantages = new Swiper(advantagesSlider, {
      slidesPerView: 1,
      effect: "fade",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    swiperImgAdvantages.on("realIndexChange", function (swiper) {
      swiperAdvantages.slideTo(swiper.activeIndex, 100, false);
    });

    swiperAdvantages.on("realIndexChange", function (swiper) {
      swiperImgAdvantages.slideTo(swiper.activeIndex, 100, false);
    });

    swiperImgAdvantages.on("reachEnd", function (swiper) {
      swiper.el.classList.add('advantages__slider-img-wrap_last')
    });

    swiperImgAdvantages.on("fromEdge", function (swiper) {
      swiper.el.classList.remove('advantages__slider-img-wrap_last')
    });
  }
})();
